<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent1"><a id="page_ii"></a><strong>Series Board</strong></p>
<p class="noindent2">James Bernauer</p>
<p class="noindent2">Drucilla Cornell</p>
<p class="noindent2">Thomas R. Flynn</p>
<p class="noindent2">Kevin Hart</p>
<p class="noindent2">Jean-Luc Marion</p>
<p class="noindent2">Adriaan Peperzak</p>
<p class="noindent2">Richard Kearney</p>
<p class="noindent2">Thomas Sheehan</p>
<p class="noindent2">Hent de Vries</p>
<p class="noindent2">Merold Westphal</p>
<p class="noindent2">Edith Wyschogrod</p>
<p class="noindent2">Michael Zimmerman</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// series.vue?4a35e59a